import { Textarea } from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useAppSelector } from "../../../redux/store";
import { IQuestionProps } from "../../../types";
import { useForm } from "react-hook-form";
import QuestionWrapper from "../../QuestionWrapper";

const CommentBox: React.FC<IQuestionProps> = ({
  defaultValue,
  onSubmit,
  onDirty,
  ...restProps
}) => {
  const { id, mandatory, routeToQuestion } = restProps;

  const {
    register,
    handleSubmit,
    formState: { isDirty, isValid },
    trigger,
  } = useForm({
    mode: "onChange",
    defaultValues: {
      value: defaultValue,
    },
  });

  const routeId = routeToQuestion;

  const theme = useAppSelector((state) => state.theme.theme);

  useEffect(() => {
    trigger();
  }, [trigger]);

  useEffect(() => {
    if (isDirty && onDirty) {
      onDirty();
    }
  }, [isDirty, onDirty]);

  return (
    <form
      id={`question-${id}`}
      onSubmit={handleSubmit((formData) => {
        if (onSubmit) {
          onSubmit(formData.value as string, { nextRoute: routeId });
        }
      })}
    >
      <QuestionWrapper isValid={isValid} {...restProps}>
        <Textarea
          placeholder="Tell us more"
          size={{ base: "sm", md: "md" }}
          resize={"none"}
          variant="filled"
          focusBorderColor={theme.primaryColor}
          {...register("value", { required: mandatory })}
        />
      </QuestionWrapper>
    </form>
  );
};

export default CommentBox;
